import { defineComponent as r, openBlock as i, createElementBlock as s, normalizeClass as t, createElementVNode as e } from "vue";
import { VSpinnerSizes as a, VSpinnerVariants as p } from "../../../packages/vsimple-ui/types/VSpinner.mjs";
const m = /* @__PURE__ */ r({
  __name: "VSpinner",
  props: {
    size: { default: a.MEDIUM },
    variant: { default: p.PRIMARY }
  },
  setup(o) {
    return (n, l) => (i(), s("div", {
      class: t([
        n.$style["v-spinner"],
        n.$style[`v-spinner--${n.variant}`],
        n.$style[`v-spinner--${n.size}`]
      ])
    }, l[0] || (l[0] = [
      e("div", null, null, -1),
      e("div", null, null, -1),
      e("div", null, null, -1),
      e("div", null, null, -1)
    ]), 2));
  }
});
export {
  m as default
};
